/**
 * Common base style shortcut definitions, intended to be mixed-in with custom style objects.
 */
import {cyan} from '@material-ui/core/colors/';

export const FullSize = {
    height: '100%',
    width: '100%'
};

export const AppBackground = {
    background: '#0a2800'
};

export const ThinBorder = {
    border: '1px solid ' + cyan[300]
}
export const SmallFont = {
    fontSize: 14,
    fontFamily: 'Arial'
};

export const MediumFont = {
    fontSize: 20,
    fontFamily: 'Arial'
};

export const LargeFont = {
    fontSize: 30,
    fontFamily: 'Arial'
};

export const TextColor = {
    color: cyan[300]
};

